import DOMPurify from 'dompurify';

export function useDomPurify() {

  const allowedTags = [
    'div',
    'p', 'img', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'strong', 'em', 'a', 'ul', 'ol', 'li',
    'figure', 'figcaption', 'br',
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
    // Specifically for Word
    'span', 'b', 'i', 'u', 'sup', 'sub',
  ];

  const allowedAttr = [
    'href', 'src', 'data-mce-src', 'id', 'class', 'target', 'rel', 'rowspan', 'colspan',
    'style',
  ];

  DOMPurify.addHook('afterSanitizeAttributes', function(node) {
    // Check if the current node is an anchor tag
    if (node.tagName === 'A') {
      // Force target="_blank"
      node.setAttribute('target', '_blank');

      // Force security attributes to prevent reverse tabnabbing
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });

  const sanitize = content => {
    return DOMPurify.sanitize(content, {
      ALLOWED_TAGS: allowedTags,
      ALLOWED_ATTR: allowedAttr,
      ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|blob):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    });
  };

  return { sanitize };
}
